import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import kebabCase from 'lodash/kebabCase'
import Text, { H1 } from 'components/common/Text/Text'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Image from 'components/common/Image'
import { CommonWrapper } from '../SharedStyles'
import banner from './assets/promo.jpg'

const BOTShopTeaser = ({ title, description, image, altTag }) =>
  <Wrapper>
    <Title data-at-heading={ kebabCase(title) } block headline centered>{ title }</Title>
    <Desc data-at-shop-description block centered size="20">{ description }</Desc>
    <BannerWrapper>
      <BannerImage data-at-shop-banner-image src={ image || banner } />
    </BannerWrapper>
  </Wrapper>

BOTShopTeaser.propTypes = {
  altTag: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string
}

BOTShopTeaser.type = 'BOTShopForTiresTeaser'

export default BOTShopTeaser

const Wrapper = styled(CommonWrapper)`
  margin-top: 30px;
`


const Title = styled(H1)`
  text-align: center;
  ${Media.desktop`
    ${Mixin.font.GothamBold(34, 900)}
  `}
  ${Media.mobile`
    ${Mixin.font.GothamBold(22, 900)}
  `}
`

const Desc = styled(Text)`
  margin-top: 15px;
  ${Media.mobile`
    font-size: 16px;
  `}
`

const BannerWrapper = styled.div`
  overflow: hidden;
  height: 365px;
  margin-top: 30px;
  border: 1px solid ${Theme.colors.light_grey};
  position: relative;
  ${Media.mobile`
    height: 165px;
  `}
`

const BannerImage = styled(Image)`
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, 0%);
  ${Media.mobile`
    width: 100%;
  `}

  @media (max-width: 680px) {
    height: 165px;
    width: auto;
  }
`
